import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function PersonalHero() {
  return <section className="relative w-full py-20 lg:py-32 overflow-hidden" data-id="element-68" data-mp="3lphhlq1hnt1a">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-69" data-mp="3grpes0zb2mib">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-[#FF5722]/10 rounded-full blur-[120px]" data-id="element-70" data-mp="i91z3m3e4geo" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-[#3B82F6]/5 rounded-full blur-[120px]" data-id="element-71" data-mp="d9xtf5fod0t3" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72" data-mp="89b5rnqkg7g6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-73" data-mp="4aaoi9nqlcva">
          {/* Text Content */}
          <div className="space-y-8" data-id="element-74" data-mp="2t24u9dni7h6x">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#1E293B] border border-[#334155]" data-id="element-75" data-mp="2sz0le2z3fx9x">
              <span className="w-2 h-2 rounded-full bg-[#FF5722] mr-2 animate-pulse" data-id="element-76" data-mp="3hit1g5dsrzu7"></span>
              <span className="text-sm font-medium text-[#94A3B8]" data-id="element-77" data-mp="3mhmc7q1p9cqo">
                Justus Kraft • CRM Expert
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-78" data-mp="38h39myg06yvw">
              From IT Developer to{' '}
              <span className="text-[#FF5722]" data-id="element-79" data-mp="3clb1h4hrcuyc">Sales Automation Expert</span>
            </h1>

            <p className="text-lg text-[#94A3B8] max-w-xl leading-relaxed" data-id="element-80" data-mp="2yq8ltpn3zr8c">
              Started my first business at 16. Now at 23, I help companies
              double their sales through intelligent CRM systems.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-81" data-mp="2tsfid4d6xbbr">
              <Button size="lg" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-83" data-mp="2fuii9xzj2msc" />} onClick={openCalendlyPopup} data-id="element-82" data-mp="2tqm8zhb70d02">
                Book Free Demo
              </Button>
            </div>

            <div className="pt-8 flex items-center gap-6 text-sm text-[#94A3B8]" data-id="element-84" data-mp="qcbty2tlmz9i">
              <div className="flex items-center gap-2" data-id="element-85" data-mp="lllnsndcmsdr">
                <CheckCircle2 className="w-4 h-4 text-[#FF5722]" data-id="element-86" data-mp="lk0wr7q8trkn" />
                <span data-id="element-87" data-mp="gnafih2pcpxn">110+ Happy Clients</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-88" data-mp="ckxbpy7in23i">
                <CheckCircle2 className="w-4 h-4 text-[#FF5722]" data-id="element-89" data-mp="cm8crq9ktvqx" />
                <span data-id="element-90" data-mp="19b6c7ls9uhuf">GDPR Compliant</span>
              </div>
            </div>
          </div>

          {/* Image/Visual Placeholder */}
          <div className="relative md:h-[450px] lg:h-[600px] flex items-center justify-center" data-id="element-91" data-mp="14cml76ytmfv7">
            <div className="relative w-full max-w-sm md:max-w-xs lg:max-w-md aspect-[4/5] rounded-2xl overflow-hidden border border-[#1E293B] shadow-2xl" data-id="element-92" data-mp="108exnd43n5yk">
              {/* Professional Photo - Optimized for performance */}
              <img src="https://cdn.magicpatterns.com/uploads/jWaCxaLsc32b7Nk2LkzDn3/62dfd10966fa026013ebcbcf_565aa1ce-min-p-1600_(3).jpg" alt="Justus Kraft - CRM Expert" className="w-full h-full object-cover" loading="eager" fetchPriority="high" decoding="async" width="800" height="1000" data-id="element-93" data-mp="3g1duuydcno3q" />

              {/* Overlay gradient for better text contrast on floating card */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E27]/60 via-transparent to-transparent" data-id="element-94" data-mp="2ea34yj6dtu14"></div>

              {/* Floating Card */}
              <div className="absolute bottom-8 right-[-20px] bg-[#141B3A] p-4 rounded-xl border border-[#334155] shadow-xl max-w-[200px] animate-bounce duration-[3000ms]" data-id="element-95" data-mp="2j733m90wjui7">
                <div className="flex items-center gap-3 mb-2" data-id="element-96" data-mp="2s8azkkfy4j94">
                  <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center text-green-500" data-id="element-97" data-mp="tu9dbpfbkapu">
                    <ArrowRight className="w-4 h-4 -rotate-45" data-id="element-98" data-mp="xutbmwbmpkdk" />
                  </div>
                  <div data-id="element-99" data-mp="2kvb2wgz9hso">
                    <p className="text-xs text-[#94A3B8]" data-id="element-100" data-mp="2k3gnoz49q3z">Revenue Growth</p>
                    <p className="text-sm font-bold text-white" data-id="element-101" data-mp="3upyxjxl95zun">
                      + $7M Generated
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}